module.exports = __webpack_public_path__ + "static/media/deathstar.7887b016.png";